
   //Code for showing price on add to cart button and try now button
 
    $(document).ready(function () {
        console.log("======New pdp=====");

//         document.addEventListener("DOMContentLoaded", function () {
//   // Run an interval to check when Loop widget is ready
//   const loopCheck = setInterval(() => {
//     const loopWidget = document.querySelector('.loop-widget-purchase-options-container');
    
//     if (loopWidget) {
//       clearInterval(loopCheck); // stop checking once found

//       const labels = document.querySelectorAll('.variant-picker__option-values .block-swatch');
//       console.log('Variant selected at init:', document.querySelector('[name="id"]').value);

//       if (labels.length > 1) {
//         const scrollY = window.scrollY;

//         labels[1].dispatchEvent(new MouseEvent("click", {
//           bubbles: true,
//           cancelable: true,
//           view: window
//         }));

//         // Restore scroll position to avoid jump
//         window.scrollTo(0, scrollY);

//         // // Optional: reinitialize Loop just in case
//         // if (window.Loop && typeof window.Loop.reInit === "function") {
//         //   window.Loop.reInit();
//         // }
//       }
//     }
//   }, 200); // check every 200ms until widget appears
// });

        
    function priceAddToCart() {
     let mprice;
        if ($(".product price-list .selling-price.money").length) {
            mprice=$(".product price-list .selling-price.money").text()
            mprice = mprice.replace("Rs.", "₹");
        }
        else{
             mprice=$(".product price-list sale-price .money").text()
             mprice = mprice.replace("Rs.", "₹");
        }
        // if ($(".loop-widget-purchase-option-selected").length) {
        //     mprice= $(".loop-widget-purchase-option-selected").find(".loop-widget-purchase-option-price").text();
        // }
     let newTxt=" - "+mprice ;
     if ($(".product buy-buttons button div span#v-price").length) {
        $(".product buy-buttons button div span#v-price").text(newTxt)
        console.log("span#v-price.lenght -"+newTxt);
     }
     else{
         $(".product buy-buttons button div").append(`<span id="v-price">${newTxt}</span>`)
         console.log("span#v-price.lenght no -"+newTxt);
     }
 
     if ($(".product button[type='submit'].try-now-button span#v-price").length) {
        $(".product button[type='submit'].try-now-button span#v-price").text(newTxt)
        console.log("try-now-button #v-price.length -"+newTxt);
     }
     else{
         $(".product button[type='submit'].try-now-button").append(`<span id="v-price">${newTxt}</span>`)
         console.log("try-now-button #v-price.length no -"+newTxt);
     }
 
    }
   var Interval = setInterval(loopSub, 800);
function loopSub(){
if($(".loop-widget-purchase-options-container").length > 0){
    console.log("-=+++",$(".product buy-buttons button div").text());
    var text = $(".product buy-buttons button div").text();

if (text.includes("SHOP NOW")) {
  console.log("Contains SHOP NOW");
  clearInterval(Interval);
  $(".product .sticky-try-now-btn button #v-price").show();
} else {
  console.log("Does NOT contain SHOP NOW");
}
    //var mprice = $(".product price-list .money").first().text();
   var mprice= $(".loop-widget-purchase-option-selected").find(".loop-widget-purchase-option-price").text();
    mprice = mprice.replace("Rs.", "₹");
    console.log("mprice3"+mprice);

  
    if ( $(".product buy-buttons button div span#v-price").length) {
        $(".product buy-buttons button div span#v-price").text(" - "+mprice);
        $(".product .sticky-try-now-btn button #v-price").text(" - "+mprice);
        console.log("subs main lenght yes -"+mprice);
        console.log("Test===",$(".product buy-buttons button div span#v-price"));
        console.log("===",$(".product buy-buttons button div").text());
        
        console.log(document.querySelector(".product buy-buttons button").outerHTML);
        
        
    }
    else{
        $(".product buy-buttons button div").append(`<span id="v-price"> - ${mprice}</span>`);
        $(".product .sticky-try-now-btn button #v-price").text(" - "+mprice);
        console.log("subs main lenght no -"+mprice);
    }
    

      $(".loop-widget-purchase-options-container").click(function () {
     console.log("Subscription click==");
     
        let txt = $(".loop-widget-purchase-option-selected").find(".loop-widget-purchase-option-price").text();
        $(".product price-list .money").first().text(txt);
          $(".product buy-buttons button[type='submit'] span#v-price").text(" - "+txt)
          $(".product button[type='submit'].try-now-button span#v-price").text(" - "+txt);   
 
           if ($(".product buy-buttons button[type='submit'] span#v-price").length) {
        $(".product buy-buttons button[type='submit'] span#v-price").text(" - "+txt)
     }
     else{
         $(".product buy-buttons button[type='submit'] div").append(`<span id="v-price"> - ${txt}</span>`)
     }
     });
    }
}
    priceAddToCart()
 
     document.addEventListener("variant:change", (e) => {
       setTimeout(() => {
        priceAddToCart();
        loopSub();
       }, 0);
 
     });
 
 window.addEventListener("beforeunload", function (e) {
    $(".variant-picker__option-values label.block-swatch").eq(1).trigger("click"); 
    });
      });